module.exports = __webpack_public_path__ + "media/img/help_center/Institution_Message_02-6b878d8f292d5a1ca14e16e075e45b38.jpg";